import BasicRootStore from 'Core/stores/basicRootStore/BasicRootStore'

import * as constants from 'Portals/Supplier/constants'
import {
	AuthStore,
	DashboardStore,
	// INJECT_FROM_PLOP_TABLELIST__IMPORT_STORE
	DocumentStore,
	HelpCenterStore,
	InvoiceStore,
	MetadataStore,
	ProfileStore,
	RegistrationDocumentStore,
	ReportStore,
	SiteVisitStore
} from 'Portals/Supplier/stores'

export class RootStore extends BasicRootStore {
	[constants.STORE_AUTH]: AuthStore;
	[constants.STORE_DASHBOARD]: DashboardStore;
	[constants.STORE_METADATA]: MetadataStore;
	[constants.STORE_INVOICE]: InvoiceStore;
	[constants.STORE_REPORT]: ReportStore;
	[constants.STORE_HELP_CENTER]: HelpCenterStore;
	[constants.STORE_PROFILE]: ProfileStore;
	[constants.STORE_REGISTRATION_DOCUMENT]: RegistrationDocumentStore;
	// INJECT_FROM_PLOP_TABLELIST__DECLARE_STORE
	[constants.STORE_DOCUMENT]: DocumentStore;
	[constants.STORE_SITE_VISIT]: SiteVisitStore

	constructor() {
		super()
		Object.assign(this, {
			[constants.STORE_AUTH]: new AuthStore(this),
			// INJECT_FROM_PLOP_TABLELIST__INITIALIZE_STORE
			[constants.STORE_DOCUMENT]: new DocumentStore(this),
			[constants.STORE_DASHBOARD]: new DashboardStore(this),
			[constants.STORE_METADATA]: new MetadataStore(this),
			[constants.STORE_INVOICE]: new InvoiceStore(this),
			[constants.STORE_REPORT]: new ReportStore(this),
			[constants.STORE_HELP_CENTER]: new HelpCenterStore(this),
			[constants.STORE_PROFILE]: new ProfileStore(this),
			[constants.STORE_REGISTRATION_DOCUMENT]: new RegistrationDocumentStore(this),
			[constants.STORE_SITE_VISIT]: new SiteVisitStore(this)
		})
	}
}
